import React from 'react';
import styled from 'styled-components';
import HeaderUserDropdownItem from './HeaderUserDropdownItem';

const HeaderUserDropdownListWrapper = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border: none;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  &:hover {
    color: var(--color-black);
    border: var(--color-light_blue_grey);
  }
`;

const HeaderUserDropdownList = ({ dropdown_list }) => {
  return (
    <HeaderUserDropdownListWrapper>
      {dropdown_list.map((element) => {
        if (element.show) {
          return (
            <HeaderUserDropdownItem
              key={element.title}
              title={element.title}
              route={element.route}
              go_back={element.go_back}
            />
          );
        }
      })}
    </HeaderUserDropdownListWrapper>
  );
};

export default HeaderUserDropdownList;
